import React, { useEffect, useState } from 'react';

const VoiceAnimation = ({ 
  status,
  isSpeaking,
  width = 280,
  height = 60 
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1); // 1 = left to right, -1 = right to left
  
  const numBars = 16;
  
  // KITT sweep effect - only when not speaking
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => {
        const next = prev + direction;
        
        if (next >= numBars - 1) {
          setDirection(-1);
          return numBars - 1;
        } else if (next <= 0) {
          setDirection(1);
          return 0;
        }
        
        return next;
      });
    }, 150);
    return () => clearInterval(interval);
  }, [direction, numBars, isSpeaking]);

  const getBarStyle = (index) => {
    // If speaking, show animated audio bars
  if (isSpeaking) {
    const randomHeight =  Math.random() * 1.6;
    const randomIntensity = Math.random();
    
    return {
      width: '10px',
      height: '28px',
       // Keep fixed height, use transform for scaling
      //display: status == 'disconnected' ? 'none': 'block',
      backgroundColor: randomIntensity > 0.7 ? '#00bcd4' : 
                      randomIntensity > 0.4 ? '#26c6da' : '#4dd0e1',
      borderRadius: '4px',
      transition: 'all 0.15s ease-out',
      transform: `scaleY(${randomHeight})`,
      top: randomHeight/2,
      opacity: 0.7 + (randomIntensity * 0.3),
      boxShadow: randomIntensity > 0.6 ? '0 0 6px rgba(0, 188, 212, 0.4)' : 'none'
    };
  }

    // KITT sweep when not speaking
    const distance = Math.abs(index - activeIndex);
    const isActive = distance <= 2;
    
    if (!isActive) {
      return {
        width: '10px',
        height: '28px',
        //display: status == 'disconnected' ? 'none': 'block',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        transition: 'all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)',
        opacity: 0.3
      };
    }
    
    if (distance === 0) {
      return {
        width: '10px',
        height: '28px',
        //display: status == 'disconnected' ? 'none': 'block',
        backgroundColor: '#00bcd4',
        borderRadius: '4px',
        transition: 'all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)',
        boxShadow: '0 0 12px rgba(0, 188, 212, 0.6)',
        opacity: 1
      };
    }
    
    if (distance === 1) {
      return {
        width: '10px',
        height: '28px',
        //display: status == 'disconnected' ? 'none': 'block',
        backgroundColor: '#26c6da',
        borderRadius: '4px',
        transition: 'all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)',
        boxShadow: '0 0 8px rgba(0, 188, 212, 0.4)',
        opacity: 0.8
      };
    }
    
    // distance === 2
    return {
      width: '10px',
      height: '28px',
      //display: status == 'disconnected' ? 'none': 'block',
      backgroundColor: '#4dd0e1',
      borderRadius: '4px',
      transition: 'all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)',
      opacity: 0.5
    };
  };

  return (
    <>
      <div style={{ 
        width, 
        height, 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        padding: '12px',
        gap: '3px',
        position: 'relative',
        width: '100%'
      }}>
        {Array.from({ length: numBars }, (_, index) => (
          <div key={index} style={getBarStyle(index)} />
        ))}
      </div>
    </>
  );
};

export default VoiceAnimation;